import { useEffect } from "react";

interface PlayerModalProps {
  open: boolean;
  title: string;
  episodeLabel: string;
  onClose: () => void;
}

export default function PlayerModal({ open, title, episodeLabel, onClose }: PlayerModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4 py-8">
      <button
        type="button"
        aria-label="关闭播放器"
        onClick={onClose}
        className="absolute inset-0 cursor-pointer bg-primary-950/80 backdrop-blur-sm"
      />
      <div className="animate-fade-up relative z-10 w-full max-w-2xl overflow-hidden rounded-lg border border-background-50/15 bg-primary-950">
        <div className="flex items-center justify-between border-b border-background-50/10 px-4 py-3">
          <p className="min-w-0 truncate text-sm text-background-100">
            <span className="font-medium text-background-50">{title}</span>
            <span className="mx-2 text-background-500">·</span>
            {episodeLabel}
          </p>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-background-200 transition-colors hover:bg-background-50/10"
          >
            <i className="ri-close-line text-lg" aria-hidden="true" />
          </button>
        </div>

        <div className="relative flex aspect-video w-full flex-col items-center justify-center bg-primary-900 px-6 text-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full border border-accent-500/50 bg-accent-500/15">
            <i className="ri-play-fill text-3xl text-accent-400" aria-hidden="true" />
          </div>
          <p className="mt-4 text-sm font-medium text-background-50">播放器演示</p>
          <p className="mt-2 max-w-sm text-xs leading-relaxed text-background-300">
            当前为前端演示播放提示，本站不接入真实视频源，也不提供任何影视资源文件下载。
          </p>
          <div className="mt-6 h-1 w-full max-w-md overflow-hidden rounded-full bg-background-50/15">
            <div className="h-full w-1/3 rounded-full bg-accent-500" />
          </div>
          <div className="mt-2 flex w-full max-w-md items-center justify-between text-[11px] text-background-400">
            <span>00:00</span>
            <span>演示模式</span>
          </div>
        </div>

        <div className="flex flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            点击其他集数可切换演示集数，真实播放需接入正版视频服务。
          </p>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-primary-950 transition-colors hover:bg-accent-400"
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
}